module.exports = __webpack_public_path__ + "static/malt-on-7f3f86590bb3ff035626115f736c3f97.svg";